import React from 'react';
import { Image } from 'Components/frameworks/image/Image';
import { Text } from 'Components/frameworks/text/Text';
type Props = {
  bundle: UpsellPackage;
};
export const AlternativePackageToolTip = ({ bundle }: Props) => (
  <div className="flex-1">
    <Image imageUrl={bundle.image} ratioKey="L" />
    <Text className="p-10" text={bundle.description} />
  </div>
);
